import axios from "axios";
import {Buffer} from 'buffer';
import { sanitizeText } from "../apoio/suporte";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

let authTokenCache = null;

const isPublicOrAuthEndpoint = (url = "") => {
  const normalizedUrl = url.toLowerCase();

  return normalizedUrl.includes("/integrador/token") ||
    normalizedUrl.includes("integrador/token") ||
    normalizedUrl.includes("/integrador/readness") ||
    normalizedUrl.includes("integrador/readness") ||
    normalizedUrl.includes("/integrador/callback") ||
    normalizedUrl.includes("integrador/callback") ||
    normalizedUrl.includes("/arquivos/") ||
    normalizedUrl.includes("arquivos/");
};

const getBearerToken = async () => {
  if (authTokenCache) {
    return authTokenCache;
  }

  const code = localStorage.getItem("code");
  const queryString = code ? `?code=${code}` : "";

  const response = await api.get(`/integrador/token${queryString}`);

  if (response && response.data && response.data.codigo === 0 && response.data.access_token) {
    authTokenCache = response.data.access_token;
    return authTokenCache;
  }

  throw new Error("Não foi possível obter token de autenticação.");
};

api.interceptors.request.use(
  async (config) => {
    const requestUrl = config?.url || "";

    if (isPublicOrAuthEndpoint(requestUrl)) {
      return config;
    }

    if (!config.headers || !config.headers.Authorization) {
      const bearerToken = await getBearerToken();
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${bearerToken}`
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const statusCode = error?.response?.status;
    const originalRequest = error?.config;
    const originalUrl = originalRequest?.url || "";

    if (statusCode === 401 && originalRequest && !originalRequest._retry && !isPublicOrAuthEndpoint(originalUrl)) {
      originalRequest._retry = true;
      authTokenCache = null;

      try {
        const bearerToken = await getBearerToken();
        originalRequest.headers = {
          ...(originalRequest.headers || {}),
          Authorization: `Bearer ${bearerToken}`
        };

        return api(originalRequest);
      }
      catch (tokenError) {
        if (typeof window !== "undefined") {
          window.location.href = "/erro/?erro=102";
        }
      }
    }

    return Promise.reject(error);
  }
);
 
// const api = axios.create({
//   baseURL: "https://integradorxs6dadoshomol.com.br/backend",
// });

// const api = axios.create({
//   baseURL: "http://localhost:5000",
// });

const api_cep = axios.create({
  baseURL: "https://viacep.com.br/ws",
});

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const replaceAll = (str, find, replace) => {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

export const pagamentoCartao = (cartao, callback) => {
  if (cartao.flag === "") {
    var resp = {
      codigo: -1,
      mensagem: "A bandeira do cartão não é aceita. Por favor, troque o cartão ou o meio de pagamento.",
      data: null
    };

    callback(resp);

    return;
  }

  let data = {
    holder_name: cartao.cardHolder,
    card_expiration: cartao.cardExpiration,
    card_number: cartao.cardNumber.replace(/\D/g, ""),
    card_cvv: cartao.cardCVV,
    payment_method_code: "credit_card",
    payment_company_code: cartao.flag
  };

  const url_pagamento = process.env.REACT_APP_API_VINDI;
  const username = process.env.REACT_APP_API_VINDI_USERNAME;
  
  axios.post(url_pagamento, data, {
    auth: {
      username: username
    },
  }).then((response) => {
    if (response) {
      var resp = {};

      if (response.status === 422) {
        resp = {
          codigo: -1,
          mensagem: "A bandeira do cartão não é aceita. Por favor, troque o cartão ou o meio de pagamento.",
          data: null
        };
      }
      else {
        resp = {
          codigo: 0,
          mensagem: "",
          data: response.data
        };
      }

      callback(resp);
    }
  })
  .catch((err) => {
    var response = {
      codigo: -2,
      mensagem: err
    }

    callback(response);
  })
}

export const pagamentoCartaoNovo = (venda, cartao, callback) => {
  if (cartao.flag === "") {
    var resp = {
      codigo: -1,
      mensagem: "A bandeira do cartão não é aceita. Por favor, troque o cartão ou o meio de pagamento.",
      data: null
    };

    callback(resp);

    return;
  }

  let data = {
    proposal_number: venda.proposta,
    payment_method: "CR",
    card: {
      flag: cartao.flag,
      number: cartao.cardNumber.replace(/\D/g, ""),
      expiry_date: cartao.cardExpiration.replace("/", ""),
      security_code: cartao.cardCVV,
      holder_name: cartao.cardHolder,
      authorizer_id: cartao.flag
    }
  };

  console.log("Pagamento Request", data);

  const url_pagamento = process.env.REACT_APP_API_PAGAMENTO;
  
  axios.post(url_pagamento, data).then((response) => {
    if (response) {
      var resp = {};

      console.log("Pagamento response", response);

      if (response.status === 409) {
        resp = {
          codigo: -1,
          mensagem: "A bandeira do cartão não é aceita. Por favor, troque o cartão ou o meio de pagamento.",
          data: null
        };
      }
      else if (response.status !== 200) {
        resp = {
          codigo: -1,
          mensagem: "Ocorreu um erro no processamento do pagamento. Tente novamente.",
          data: null
        };        
      }
      else {
        resp = {
          codigo: 0,
          mensagem: "",
          data: response.data
        };
      }

      callback(resp);
    }
  })
  .catch((err) => {
    var response = {
      codigo: -2,
      mensagem: err
    }

    callback(response);
  })
}

export const pesquisa_cep = (cep, callback) => {
  cep = replaceAll(cep, '-', '');

  console.log(cep);

  if (cep.length === 8) {
    api_cep.get("/" + cep + "/json/").then((response) => {
      callback(response.data);
    })
    .catch((err) => {
      var response = {
        codigo: -1,
        mensagem: err
      }

      callback(response);    
    })  
  }
  else {
    callback(null);    
  }
}

export const pagamento = (id_venda, gateway_token, callback) => {
  let data = {
    id_venda: id_venda,
    gateway_token: gateway_token
  }

  api.post("venda/pagamento", data).then((response) => {
    if (response) {
      callback(response.data);
    }
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    };

    callback(response);
  });
}

export const getContaById = (id, callback) => {
  let data = {
    id: id
  }

  api.post("/venda/retorna_conta_pelo_id", data).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const salvarProduto = (produto, callback) => {
  let data = {
    codigo: produto.codigo,
    descricao: produto.descricao,
    descricao_logado: produto.descricao_logado,
    descricao_mobile: produto.descricao_mobile,
    proposta: produto.proposta,
    proposta_recorrente: produto.proposta_recorrente,
    codigo_caixa_1: produto.codigo_caixa_1,
    codigo_caixa_2: produto.codigo_caixa_2,
    valor: parseFloat(produto.valor),
    descricao_dobro: produto.descricao_dobro,
    proposta_dobro: produto.proposta_dobro,
    proposta_dobro_recorrente: produto.proposta_dobro_recorrente
  }

  api.post("/produto/salvar", data).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const getPropostaId = (id, callback) => {
  let data = {
    id: id
  };

  api.post("/venda/proposta_pelo_id", data)
  .then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const isPropostasCpfCnpj = (cpf_cnpj, callback) => {
  let data = {
    cpf_cnpj: cpf_cnpj
  };

  api.post("/venda/existe_propostas_pelo_cpf_cnpj", data)
  .then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const getPropostasCpfCnpj = (cpf_cnpj, callback) => {
  let data = {
    cpf_cnpj: cpf_cnpj
  };

  api.post("/venda/propostas_pelo_cpf_cnpj", data)
  .then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const getProduto = (codigo, callback) => {
  let data = {
    codigo: codigo
  };

  api.post("/produto/retorna_produto", data)
  .then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const getProposta2Via = (id_venda, cod_produto, recorrencia, callback) => {
  let data = {
    id_venda: id_venda,
    cod_produto: cod_produto,
    recorrencia: recorrencia
  };

  api.post("/venda/gera_proposta_2via", data)
  .then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const getProposta = (id_venda, cod_produto, recorrencia, callback) => {
  let data = {
    id_venda: id_venda,
    cod_produto: cod_produto,
    recorrencia: recorrencia
  };

  api.post("/venda/gera_proposta", data)
  .then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const getToken = (code, callback) => {
  api.get("/integrador/token?code=" + code).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const getListaProdutos = (callback) => {
  api.get("/produto/listaProdutos").then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const getSolicitacao = (access_token, callback) => {
  let request = {
    access_token: access_token,
    id_pre_venda: parseInt(localStorage.getItem("IdPreVenda"))
  }

  api.post("/integrador/solicitacao", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const getUnidadePeloCodigo = (codigo, callback) => {
  let request = {
    codigo: codigo
  }

  api.post("/venda/retorna_unidade_pelo_codigo", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const getAgencia = (codigo, callback) => {
  let request = {
    codigo: codigo
  }

  api.post("/venda/retorna_agencia", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const getEmpregado = (cpf, callback) => {
  let request = {
    cpf: cpf
  }

  api.post("/venda/retorna_empregado_pelo_cpf", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const getVenda = (callback) => {
  let request = {
    id_pre_venda: parseInt(localStorage.getItem("IdPreVenda"))
  }

  api.post("/venda/retorna_venda", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const gerarBoleto2via = (id_venda, callback) => {
  let request = {
    id_venda: id_venda
  }

  api.post("/venda/gera_boleto_2via", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const gerarBoleto = (cpf, valor, nome, tipo, num_proposta, id_venda, callback) => {
  let request = {
    cpf: cpf,
    valor: parseFloat(replaceAll(valor, ',', '.')),
    nome: nome,
    tipo: tipo,
    num_proposta: num_proposta,
    id_venda: id_venda
  }

  api.post("/venda/gerar_boleto", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const downloadBoleto = (id, url, callback) => {
  let request = {
    id: id,
    url: url
  }

  api.post("/venda/salvar_boleto", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const situacaoPagamentoNovo = (nsu, callback) => {
  api.get("/venda/pagamento_status/" + nsu).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const situacaoPagamento = (proposta, callback) => {
  api.get("/venda/situacao_pagamento/" + proposta).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);
  })
}

export const finalizaVenda = (proposta, callback) => {
  let request = {
    id: proposta.id,
    numero_proposta: proposta.proposta,
    agencia: ((proposta.vendedor.agencia.trim() === "") ? proposta.agencia : proposta.vendedor.agencia),
    id_produto: proposta.produto.id,
    recorrencia: proposta.renovacaoAutomatica,
    cpf_vendedor: proposta.vendedor.cpf,
    matricula_vendedor: proposta.vendedor.matricula,
    id_pre_venda: proposta.id_pre_venda,
    pagamento: proposta.pagamento,
    id_conta_pagamento: proposta.conta_pagamento.id,
    agencia_pagamento: proposta.conta_pagamento.agencia,
    produto_pagamento: proposta.conta_pagamento.produto,
    conta_pagamento: proposta.conta_pagamento.conta,
    digito_pagamento: proposta.conta_pagamento.digito,
    celular: replaceAll(replaceAll(replaceAll(replaceAll(proposta.celular, "(", ""), ")", ""), " ", ""), "-", ""),
    email: proposta.email,
    codigo_barras: proposta.boleto.codigo_barras,
    linha_digitavel: proposta.boleto.linha_digitavel,
    url: proposta.boleto.url,
    venda_sms: proposta.venda_sms,
    arquivo_nome: proposta.arquivo_proposta.nome,
    arquivo_tamanho: proposta.arquivo_proposta.tamanho,
    arquivo_tipo: proposta.arquivo_proposta.tipo,
    arquivo_base64: proposta.arquivo_proposta.arquivo,
    arquivo_documento: proposta.arquivo_proposta.documento,
    data_pagamento: proposta.data_pagamento
  }

  api.post("/venda/finalizar", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const finalizaAnexo = (proposta, callback) => {
  let request = {
    id: proposta.id,
    arquivo_nome: proposta.arquivo_proposta.nome,
    arquivo_tamanho: proposta.arquivo_proposta.tamanho,
    arquivo_tipo: proposta.arquivo_proposta.tipo,
    arquivo_base64: proposta.arquivo_proposta.arquivo,
    arquivo_documento: proposta.arquivo_proposta.documento
  }

  api.post("/venda/finalizar_anexo", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const atualizaVenda = (proposta, callback) => {
  let request = {
    id: proposta.id,
    agencia: ((proposta.vendedor.agencia.trim() === "") ? proposta.agencia : proposta.vendedor.agencia),
    id_produto: proposta.produto.id,
    recorrencia: proposta.renovacaoAutomatica,
    cpf_vendedor: proposta.vendedor.cpf,
    matricula_vendedor: proposta.vendedor.matricula,
    id_pre_venda: proposta.id_pre_venda,
    pagamento: proposta.pagamento,
    id_conta_pagamento: proposta.conta_pagamento.id,
    agencia_pagamento: proposta.conta_pagamento.agencia,
    produto_pagamento: proposta.conta_pagamento.produto,
    conta_pagamento: proposta.conta_pagamento.conta,
    digito_pagamento: proposta.conta_pagamento.digito,
    celular: replaceAll(replaceAll(replaceAll(replaceAll(proposta.celular, "(", ""), ")", ""), " ", ""), "-", ""),
    email: proposta.email,
    data_pagamento: proposta.data_pagamento,
    venda_cep: proposta.logradouro.cep,
    venda_endereco: sanitizeText(proposta.logradouro.endereco),
    venda_bairro: sanitizeText(proposta.logradouro.bairro),
    venda_cidade: sanitizeText(proposta.logradouro.cidade),
    venda_estado: proposta.logradouro.uf,
    venda_numero: proposta.logradouro.numero,
    venda_complemento: sanitizeText(proposta.logradouro.complemento)
  }

  api.post("/venda/atualizar_venda", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const getNumeroProposta = (id, agencia, callback) => {
  let request = {
    id: id,
    agencia: agencia
  }

  api.post("/venda/gerar_numero_proposta", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const enviarSMS = (id, idConta, idProduto, pagamento, recorrencia, celular, origem, proposta, callback) => {
  let request = {
    id: id,
    idConta: idConta,
    idProduto: idProduto,
    pagamento: pagamento,
    recorrencia: recorrencia,
    celular: celular,
    proposta: proposta,
    origem: origem
  }

  api.post("/integrador/enviar_sms_token", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const enviarWhats = (id, idConta, idProduto, pagamento, recorrencia, celular, origem, proposta, callback) => {
  let request = {
    id: id,
    idConta: idConta,
    idProduto: idProduto,
    pagamento: pagamento,
    recorrencia: recorrencia,
    celular: celular,
    proposta: proposta,
    origem: origem
  }

  api.post("/integrador/enviar_whats_token", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const cancelarProposta = (id, callback) => {
  let request = {
    id: id
  };

  api.post("/venda/cancelar_proposta", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}

export const fakeCallBack = (proposta, callback) => {
  let request = {
    proposta: {
      cliente: {
        coCli: "2060040306206",
        formaVenda: {
          canal: proposta.formaVenda
        },
        produto: {
          codigoCorporativo: 6023
        },
        endereco: {
          uf: proposta.uf,
          cidade: proposta.cidade,
          bairro: "SANTO AMARO",
          logradouro: "Rua Lorenzo, 564",
          codigoCidade: "3045",
          cep: "09056234"
        },
        pv: {
          vendedor: {
            usuario: proposta.matricula_vendedor,
            nome: proposta.nome_vendedor,
          },
          data: "20210122",
          horario: "18:35:13",
          agencia: proposta.agencia,
          codCanal: (proposta.formaVenda === "CCA" ? "002" : "001"),
          codPv: "9393333",
          ag: proposta.agencia,
          us: "A21313",
          cpfParceiro: proposta.cpf_vendedor
        },
        pf: {
          naturalidade: {
            localidade: "30",
            paisOrigem: "1",
            nacionalidade: "BRASILEIRO"
          },
          tipoPessoa: (proposta.cpf.trim().length > 11 ? "2" : "1"),
          rg: {
            datatEmissao: "20001002",
            numero: "5588779",
            emissor: {
              uf: "DF",
              codigo: "70",
              nome: "CREFI"
            }
          },
          profissao: {
            nome: "AGENTE POL"
          },
          sexo: proposta.pf.sexo,
          cpf: proposta.cpf,
          estadoCivil: "7",
          nome: proposta.nome,
          datatNascimento: proposta.dataNascimento,
          contato: {
            celular: {
              numero: proposta.celular.substr(2,9),
              ddd: proposta.celular.substr(0,2)
            },
            residencial: {
              ddd: "0"
            },
            email: "CESARRAC@GMAIL.COM"
          },
          codNicho: "0076",
          renda: {
            tipo: 0
          }
        },
        pj:{
          razaoSocial:"",
          cnae:"",
          cei: "",
          natJur:"",
          cnpj:"",
          nomeReduzido:"",
          nomeFantasia:"",
          dataConst:"",
          porte:0,      
          mensaDadosMei: (proposta.mei === "N") ? null : proposta.mei,
          faturamento: {
            valor: 0
          },
          contato:{
            comercial:{
               ddd2:"",
               numero1:"",
               numero2:"",
               ddd1:"",
               numeroFax:"",
               dddFax:""
            },
            email:""
         },
         codNicho:""
        },
        contas: [
        ],
        carteria: "FC04"
      },
      id_pre_venda: parseInt(proposta.id_pre_venda)
    }
  }

  let conta;

  if (proposta.conta1 !== "" && proposta.conta1 !== "" && proposta.digito1 !== "") {
    conta = {
      digitoVerificador: proposta.digito1,
      produto: "1288",
      numero: proposta.conta1,
      agencia: proposta.agencia1
    }

    request.proposta.cliente.contas.push(conta);
  }

  if (proposta.conta2 !== "" && proposta.conta2 !== "" && proposta.digito2 !== "") {
    conta = {
      digitoVerificador: proposta.digito2,
      produto: "1288",
      numero: proposta.conta2,
      agencia: proposta.agencia2
    }

    request.proposta.cliente.contas.push(conta);
  }

  if (proposta.conta3 !== "" && proposta.conta3 !== "" && proposta.digito3 !== "") {
    conta = {
      digitoVerificador: proposta.digito3,
      produto: "1288",
      numero: proposta.conta3,
      agencia: proposta.agencia3
    }

    request.proposta.cliente.contas.push(conta);
  }

  api.post("/integrador/callback", request).then((response) => {
    callback(response.data);
  })
  .catch((err) => {
    var response = {
      codigo: -1,
      mensagem: err
    }

    callback(response);    
  })  
}
